import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import "@/assets/styles/legal.css";
import SidebarComponent from "@/components/SidebarComponent.vue";
import FooterImpressum from "@/components/FooterImpressum.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'ImpressumView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[0] || (_cache[0] = _createStaticVNode("<section class=\"legal-page\"><div class=\"legal-container\"><span class=\"legal-badge\"> Impressum </span><h1> Angaben gemäß § 5 TMG </h1><div class=\"legal-card\"><h2>Unternehmen</h2><p> TestGarten<br> Garten- &amp; Landschaftsbau<br> Max Mustermann </p></div><div class=\"legal-card\"><h2>Adresse</h2><p> Musterstraße 12<br> 65183 Wiesbaden<br> Deutschland </p></div><div class=\"legal-card\"><h2>Kontakt</h2><p> Telefon: +49 123 456789<br> E-Mail: info@testgarten.de </p></div><div class=\"legal-card\"><h2>Verantwortlich für den Inhalt</h2><p> Max Mustermann<br> Musterstraße 12<br> 65183 Wiesbaden </p></div><div class=\"legal-card\"><h2>Haftungshinweis</h2><p> Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die Inhalte externer Links. Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber verantwortlich. </p></div></div></section>", 1)),
    _createVNode(SidebarComponent),
    _createVNode(FooterImpressum)
  ], 64))
}
}

})